<template>
  <div class="special-banner" v-if="items.length">
    <div class="special-banner-grid" :style="gridStyle">
      <div class="special-banner-item" v-for="(it, idx) in items" :key="idx">
        <a v-if="it.link" :href="it.link" target="_blank" rel="noopener">
          <img :src="it.image" alt="special banner" />
        </a>
        <img v-else :src="it.image" alt="special banner" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpecialBanner",
  props: {
    banner: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    items() {
      if (!this.banner) return [];
      const list = [
        { image: this.banner.image, link: this.banner.link },
        { image: this.banner.image02, link: this.banner.link02 },
        { image: this.banner.image03, link: this.banner.link03 },
        { image: this.banner.image04, link: this.banner.link04 },
        { image: this.banner.image05, link: this.banner.link05 }
      ];
      return list.filter((it) => it && this.isValidImage(it.image));
    },
    gridStyle() {
      const cols = Math.min(Math.max(this.items.length, 1), 5);
      return { gridTemplateColumns: `repeat(${cols}, 1fr)` };
    }
  },
  methods: {
    isValidImage(url) {
      if (!url || typeof url !== 'string') return false;
      // Accept jpg, jpeg, gif, png, webp (case-insensitive), allow query/hash suffixes
      const pattern = /\.(jpg|jpeg|gif|png|webp)(\?.*)?(#.*)?$/i;
      return pattern.test(url.trim());
    }
  }
};
</script>

<style scoped>
.special-banner {
  margin: auto;
  max-width: 1120px;
  z-index: 100;
}
.special-banner-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  align-items: stretch;
}
.special-banner-item img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  position: relative;
}
</style>
